import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryListComponent } from './category-list.component';

@NgModule({
    declarations: [CategoryListComponent],
    imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule, MatProgressSpinnerModule, TranslateModule],
    exports: [CategoryListComponent],
})
export class CategoryListModule {}
